import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { TrendingUp, Target, Brain, Activity } from "lucide-react";

const domains = [
  {
    name: "Memory",
    score: 85,
    improvement: "+5%",
    icon: Brain
  },
  {
    name: "Attention",
    score: 92,
    improvement: "+3%",
    icon: Activity
  },
  {
    name: "Processing Speed",
    score: 78,
    improvement: "+7%",
    icon: TrendingUp
  }
];

const goals = [
  {
    title: "Complete Weekly Assessments",
    progress: 75,
    target: "3/4 completed"
  },
  {
    title: "Improve Memory Score",
    progress: 90,
    target: "Target: 95%"
  },
  {
    title: "Practice Daily Exercises",
    progress: 60,
    target: "15/30 days"
  }
];

const ProgressTracking = () => {
  return (
    <div className="max-w-6xl mx-auto p-6 space-y-8">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">Progress Tracking</h2>
        <Button>
          <Target className="w-4 h-4 mr-2" />
          Set New Goal
        </Button>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {domains.map((domain) => (
          <Card key={domain.name} className="p-6">
            <div className="flex items-center space-x-4">
              <div className="p-3 rounded-full bg-primary/10">
                <domain.icon className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold">{domain.name}</h3>
                <div className="flex items-baseline space-x-2">
                  <span className="text-2xl font-bold">{domain.score}%</span>
                  <span className="text-sm text-green-500">{domain.improvement}</span>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>

      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-6">Current Goals</h3>
        <div className="space-y-6">
          {goals.map((goal) => (
            <div key={goal.title} className="space-y-2">
              <div className="flex justify-between">
                <span className="font-medium">{goal.title}</span>
                <span className="text-sm text-muted-foreground">{goal.target}</span>
              </div>
              <Progress value={goal.progress} />
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default ProgressTracking;